import { mapProjectContactTypes, ProjectContactType } from "./ProjectContactType";
import { mapProjectServiceTypes, ProjectServiceType } from "./ProjectServiceType";
import { mapProjectShortcutFolderss, ProjectShortcutFolders } from "./ProjectShortcutFolders";

export interface SharedFolderProject {
    project_id?: number;
    job_number?: string;
    subscription_id?: number;
    subscription_name?: string;
    order_number?: number;
    contact_id?: number;
    project_type?: string;
    status?: string;
    end_of_date?: string;
    description?: string | null;
    address?: string;
    city?: string;
    post_code?: string;
    client_id?: number;
    company_name?: string;
    service_type?: ProjectServiceType[];
    license_with_key_id?: number;
    project_for?: string;
    shortcut_folders?: ProjectShortcutFolders[];
    contact?: ProjectContactType[];
    project_start_date?: string;
    project_end_date?: string;
    this_project_active?: 1 | 0;
}

// to single object maping
export const mapSharedFolderProject = (data:any): SharedFolderProject => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: SharedFolderProject ={
        project_id: data.project_id,
        job_number: data.job_number,
        subscription_id: data.subscription_id,
        subscription_name: data.subscription_name,
        order_number: data.order_number,
        contact_id: data.contact_id,
        project_type: data.project_type,
        status: data.status,
        end_of_date: data.end_of_date,
        description: data.description,
        address: data.address,
        city: data.city,
        post_code: data.post_code,
        client_id: data.client_id,
        company_name: data.company_name,
        service_type:mapProjectServiceTypes(data.service_type) ,
        license_with_key_id: data.license_with_key_id,
        project_for: data.project_for,
        shortcut_folders:mapProjectShortcutFolderss(data.shortcut_folders) ,
        contact:mapProjectContactTypes(data.contact) ,
        project_start_date: data.project_start_date,
        project_end_date: data.project_end_date,
        this_project_active: data.this_project_active,
    }
    return res;
}

// maping list objects
export const mapSharedFolderProjects = (data:any[]): SharedFolderProject[] => {
     if (!Array.isArray(data)) {
       throw new Error('Invalid Data');
     }
     return data.map(mapSharedFolderProject);
}
